(() => {
  if (window.LyvWelCartRewards) return;

  class LyvWelCartRewardsController {
    constructor() {
      this.persistedValue = null;
      this.pendingValue = null;
      this.requestSequence = 0;
      this.handleChange = this.handleChange.bind(this);
      this.sync = this.sync.bind(this);

      document.addEventListener('change', this.handleChange);
      this.observer = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length)) {
          this.sync();
        }
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.sync();
    }

    get roots() {
      return Array.from(document.querySelectorAll('[data-cart-rewards]'));
    }

    getState() {
      const roots = this.roots;
      if (!roots.length) return null;
      const root = roots[0];
      const mode = root.dataset.giftMode || 'none';
      const gum = root.dataset.gumGift || '';
      const chews = root.dataset.chewsGift || '';
      const both = root.dataset.bothGifts || '';
      const serverValue = root.dataset.currentGift || '';
      const current = this.persistedValue === null ? serverValue : this.persistedValue;
      return {
        roots,
        root,
        mode,
        gum,
        chews,
        both,
        current,
        updateUrl: root.dataset.updateUrl || '/cart/update.js',
      };
    }

    desiredValue(state) {
      if (state.mode === 'both') return state.both;
      if (state.mode === 'choice' && [state.gum, state.chews].includes(state.current)) return state.current;
      return '';
    }

    sync() {
      const state = this.getState();
      if (!state) return;
      const desired = this.desiredValue(state);
      this.updateInterface(state, state.current);
      if (desired !== state.current && desired !== this.pendingValue) {
        this.persist(desired, state, true);
        return;
      }
    }

    handleChange(event) {
      const input = event.target.closest('[data-gift-option]');
      if (!input || !input.checked) return;
      const state = this.getState();
      if (!state || state.mode !== 'choice') return;
      this.persist(input.value, state, false);
    }

    async persist(value, state, automatic) {
      const requestSequence = ++this.requestSequence;
      const previous = state.current;
      this.pendingValue = value;
      if (!automatic) this.showMessage(state, 'Saving your gift selection...', false);

      try {
        const response = await fetch(state.updateUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ attributes: { 'Free gift': value } }),
        });
        if (!response.ok) throw new Error(`Cart update failed with status ${response.status}`);
        await response.json();
        if (requestSequence !== this.requestSequence) return;
        this.persistedValue = value;
        this.pendingValue = null;
        state.roots.forEach((root) => {
          root.dataset.currentGift = value;
        });
        const refreshed = this.getState();
        if (!refreshed) return;
        this.updateInterface(refreshed, value);
        if (!automatic) this.showMessage(refreshed, 'Selection saved. Packed with this order at no charge.', false);
        this.sync();
      } catch (error) {
        if (requestSequence !== this.requestSequence) return;
        this.pendingValue = null;
        this.persistedValue = previous;
        const refreshed = this.getState() || state;
        this.updateInterface(refreshed, previous);
        this.showMessage(refreshed, 'We could not save your gift. Try again, or continue to checkout.', true);
      }
    }

    updateInterface(state, value) {
      state.roots.forEach((root) => {
        const hasChoice = state.mode === 'choice' && [state.gum, state.chews].includes(value);
        const isCartReward = root.classList.contains('lw-rewards--cart');
        root.classList.toggle('lw-rewards--selected', isCartReward && hasChoice);

        root.querySelectorAll('[data-gift-option]').forEach((input) => {
          input.checked = input.value === value;
        });

        const headline = root.querySelector('[data-gift-headline]');
        if (headline && state.mode === 'choice') {
          let headlineText;
          if (hasChoice) {
            const giftName = value === state.gum ? 'Peach Energy Gum' : 'Watermelon Energy Chews';
            headlineText = `Free gift selected: ${giftName}`;
          } else {
            headlineText = 'Choose your free gift';
          }
          if (headline.textContent !== headlineText) headline.textContent = headlineText;
        }

        const disclosure = root.querySelector('[data-gift-disclosure]');
        if (disclosure) {
          disclosure.open = !hasChoice;
          const summary = disclosure.querySelector('summary');
          const summaryText = hasChoice ? 'Change gift' : 'Choose your free gift';
          if (summary && summary.textContent !== summaryText) summary.textContent = summaryText;
        }
      });
    }

    showMessage(state, message, isError) {
      state.roots.forEach((root) => {
        const output = root.querySelector('[data-gift-message]');
        if (!output) return;
        output.textContent = message;
        output.classList.toggle('is-error', isError);
        if (isError) root.querySelector('[data-gift-disclosure]')?.setAttribute('open', '');
      });
    }
  }

  window.LyvWelCartRewards = new LyvWelCartRewardsController();
})();
